import { OnlyIElementsStore } from "@/store/ielements-slice-selector";
import {
  selectIElementChildren,
  selectIElementWorldPosition,
} from "@faro-lotv/app-component-toolbox";
import { IElementImg360, IElementTypeHint } from "@faro-lotv/ielement-types";
import { Matrix4, Quaternion, Vector3 } from "three";

/** A reusable rotation Matrix4 */
const ROTATION_MATRIX = new Matrix4();

/** A Vector3 indicating y-up */
const Y_UP = new Vector3(0, 1, 0);

/** A reuseable vector used to hold the target position */
const TARGET_POSITION = new Vector3();

/** A reusable vector which indicates where the camera should look at */
const TARGET_LOOK_AT = new Vector3();

/** A reusable quaternion used to hold final rotation of the pano */
const ROTATION = new Quaternion();

/** The default camera orientation when opening a pano for the first time */
export const DEFAULT_LOOK_AT_DIR = new Vector3(-1, 0, 0);

/**
 * @returns the rotation of the given Img360 element only if it's in the odometric path else undefined
 * @param pano Img360 element whose rotation needs to be calculated if it is inside the odometric path
 */
export function selectCameraRotationForOdometricPathPano(pano: IElementImg360) {
  return (state: OnlyIElementsStore): Quaternion | undefined => {
    if (pano.typeHint !== IElementTypeHint.odometryPath || !pano.parentId) {
      return;
    }
    // All the panos in the odometric path
    const panos = selectIElementChildren(pano.parentId)(state);

    const panoIndex = panos.findIndex((elem) => elem.id === pano.id);
    if (panoIndex === -1) return;

    const nextPanoIndex = Math.min(panos.length - 1, panoIndex + 1);
    const prevPanoIndex = Math.max(0, panoIndex - 1);

    const isLastPano = panoIndex === nextPanoIndex;

    TARGET_POSITION.fromArray(
      selectIElementWorldPosition(
        isLastPano ? panos[prevPanoIndex].id : pano.id,
      )(state),
    );

    TARGET_LOOK_AT.fromArray(
      selectIElementWorldPosition(
        isLastPano ? pano.id : panos[nextPanoIndex].id,
      )(state),
    );

    return ROTATION.setFromRotationMatrix(
      ROTATION_MATRIX.lookAt(TARGET_POSITION, TARGET_LOOK_AT, Y_UP),
    );
  };
}
